// 二手交易页面
import secondSelf from '@/pages/secondSelf'
export default {
  className: 'secondHand',
  // readonly: true,
  fields: [
    {
      name: 'secondTitle',
      validators: [
        // 可以使用多个验证，依次执行，碰到第一个错误时停止验证
        (value) => value ? null : '不可为空'
      ]
    },
    {
      name: 'secondImg'
    },
    {
      name: 'deelType',
      width: 200,
      validators: [
        // 可以使用多个验证，依次执行，碰到第一个错误时停止验证
        (value) => value ? null : '不可为空'
      ]
    },
    {
      name: 'secondClassify',
      width: 200,
      validators: [
        // 可以使用多个验证，依次执行，碰到第一个错误时停止验证
        (value) => value ? null : '不可为空'
      ]
    },
    {
      name: 'address',
      validators: [
        // 可以使用多个验证，依次执行，碰到第一个错误时停止验证
        (value) => value ? null : '不可为空'
      ]
    },
    {
      name: 'price',
      width: 150,
      validators: [
        // 可以使用多个验证，依次执行，碰到第一个错误时停止验证
        (value) => value ? null : '不可为空'
      ]
    },
    {
      name: 'user',
      note: '发布用户',
      validators: [
        // 可以使用多个验证，依次执行，碰到第一个错误时停止验证
        (value) => value ? null : '不可为空'
      ]
    },
    {
      name: 'phone',
      validators: [
        (val) => {
          if (val && !(/^1[3456789]\d{9}$/.test(val))) {
            return '请输入正确的手机号码'
          }
        }
      ]
    },
    {
      name: 'weChatNumber',
      width: 150
    },
    {
      name: 'mailbox',
      width: 150
    }
  ],
  search: [
    'deelType',
    'secondClassify'
  ],
  action: {
    create: {
      component: secondSelf
    },
    export: false,
    delete: false,
    view1: {
      type: 'row',
      text: '删除',
      callback: async ({ record, vm, className }) => {
        await vm.confirm('警告', '你确定要删除这条记录吗?')
        // 刪除此条商家信息
        let rs = await vm.$tkParse.put('/classes/' + className + '/' + record.objectId, { isDelete: true }).catch(() => {
          this.$notification['error']({
            message: '网络错误',
            description: '删除数据失败'
          })
        })
        if (rs) {
          vm.$notification['success']({
            message: '操作成功',
            description: ''
          })
          vm.refresh()
        }
      }
    }
  },
  hooks: {
    beforeFetch ({ where }) {
      where.isDelete = false
    }
  }
}
